import React from 'react';
import { createBrowserRouter, Navigate, Outlet } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';
import Layout from './components/Layout';
import HomePage from './pages/HomePage'
import EventsPage from './pages/EventsPage'
import EventShowPage from './pages/EventShowPage'
import NewEventPage from './pages/NewEventPage'
import EditEventPage from './pages/EditEventPage'
import NewSalePage from './pages/NewSalePage'
import SaleShowPage from './pages/SaleShowPage'
import EditSalePage from './pages/EditSalePage'
import LoginPage from './pages/LoginPage'
import RegisterPage from './pages/RegisterPage'
import AccountPage from './pages/AccountPage'
import TermsPage from './pages/TermsPage'
import PrivacyPage from './pages/PrivacyPage'
import CitiesPage from './pages/CitiesPage'

// Protected Route wrapper component
const ProtectedRoute = () => {
  const { user } = useAuth();
  return user ? <Outlet /> : <Navigate to="/login" />;
};

// Public Route wrapper component (redirects to home if already logged in)
const PublicRoute = () => {
  const { user } = useAuth();
  return !user ? <Outlet /> : <Navigate to="/" />;
};

export const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        index: true,
        element: <HomePage />
      },
      {
        element: <PublicRoute />,
        children: [
          {
            path: 'login',
            element: <LoginPage />
          },
          {
            path: 'register',
            element: <RegisterPage />
          }
        ]
      },
      {
        element: <ProtectedRoute />,
        children: [
          {
            path: 'account',
            element: <AccountPage />
          },
          {
            path: 'events/new',
            element: <NewEventPage />
          },
          {
            path: 'events/:id/edit',
            element: <EditEventPage />
          }
        ]
      },
      // Public routes
      {
        path: 'events',
        element: <EventsPage />
      },
      {
        path: 'search/:searchTerm/:radius?/:sortBy?',
        element: <EventsPage />
      },
      {
        path: 'cities/:searchTerm',
        element: <EventsPage />
      },
      {
        path: 'events/:id',
        element: <EventShowPage />
      },
      {
        path: 'events/:id/sales/new',
        element: <NewSalePage />
      },
      {
        path: 'events/:eventId/sales/:id',
        element: <SaleShowPage />
      },
      {
        path: 'events/:eventId/sales/:id/edit',
        element: <EditSalePage />
      },
      {
        path: 'cities',
        element: <CitiesPage />
      },
      {
        path: 'terms',
        element: <TermsPage />
      },
      {
        path: 'privacy',
        element: <PrivacyPage />
      }
    ]
  }
]) 